// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiGroupFilterDirection } from '../models/ApiGroupFilterDirection';
import { HttpFile } from '../http/http';

export class ApiGroupRepFilter {
    'min': number | null;
    'max': number | null;
    'category': string | null;
    'user_identity': string | null;
    'direction': ApiGroupFilterDirection | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "min",
            "baseName": "min",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "max",
            "baseName": "max",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "category",
            "baseName": "category",
            "type": "string",
            "format": ""
        },
        {
            "name": "user_identity",
            "baseName": "user_identity",
            "type": "string",
            "format": ""
        },
        {
            "name": "direction",
            "baseName": "direction",
            "type": "ApiGroupFilterDirection",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiGroupRepFilter.attributeTypeMap;
    }

    public constructor() {
    }
}



